import moment from "moment";
import { University } from "../interfaces";
import { capitalizeString, getCityNameByCode } from "../shared/util";

export class UniversitiesAdapter {
    value: any;

    constructor(input: any) {
        this.value = input;
    }

    get institution_name() {
        return capitalizeString(this.value.institution_name || '');
    }

    get city() {
        if (!this.value.city) {
            return this.value.cityRaw || 'No Informa'
        }

        return getCityNameByCode(this.value.city)?.municipio || 'No definido';
    }

    get state() {
        if (!this.value.state) {
            return this.value.stateRaw || 'No Informa'
        }
        return getCityNameByCode(this.value.city)?.departamento || 'No definido';
    }

    get municipality() {
        return getCityNameByCode(this.value.city).municipio;
    }

    get contact_name() {
        return capitalizeString(this.value.contact_name || '');
    }

    get contact_email() {
        return this.value.contact_email || '';
    }

    get update_date() {
        return moment(this.value.update_date).format("YYYY-MM-DD");
    }
    get created_at() {
        return moment(this.value.created_at).format("YYYY-MM-DD");
    }

    get current_date() {
        return moment(this.value.current_date).format("YYYY-MM-DD");
    }

    get issue_date() {
        return moment(this.value.issue_date).format("YYYY-MM-DD");
    }

    get updated_at() {
        return moment(this.value.updated_at).format("YYYY-MM-DD");
    }

    get is_accredited(){
        return this.value.is_accredited ===  1 ? 'Si' :'No'
    }

    adapt(): University {
        return {
            id: this.value.id,
            is_accredited: this.is_accredited,
            institution_code: this.value.institution_code,
            institution_name:this.institution_name,
            municipality: this.municipality,
            state: this.state,
            phone : this.value.phone,
            universities_entities: [],
            universities_searchers: [],
            url: this.value.url,
            searchers: this.value.searchers,
            description: this.value.description,
            features: this.value.features,
            contact_name: this.contact_name,
            contact_email: this.contact_email,
            issue_date: this.issue_date,
            current_date: this.current_date,
            created_at: this.created_at || '',
            updated_at: this.updated_at || '',
            update_date: this.update_date || '',
            actor_type: this.value.actor_type,
            recognized_min: this.value.recognized_min === 1 ? "Si" : 'No',
            source: this.value.source || '',
            city: capitalizeString(this.value.city || ''),
        };
    }
}
